import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import UserProfileComponent from './UserProfile';

import * as filtersActions from '../../actions/filters-actions';
import * as reportBuilderActions from '../../actions/report-builder-actions';
import * as userActions from '../../actions/auth-actions';

import {
  saveAudienceSegment,
  updateFilterOptions,
  deleteAudienceSegment
} from '../../actions/audience-segment-actions';
import { selectConfig, selectFilters } from '../../reducers/filters-reducer';
import { getUserInfo } from '../../reducers/user-reducer';
import { selectId, selectName } from '../../reducers/audience-segment-reducer';
import { selectMyReports } from '../../reducers/report-builder-reducer';
import { defaultStateForMapStateToProps } from '../../utils/redux';

import './UserProfile.css';

const defaultState = {
  filters: selectFilters,
  user: getUserInfo,
  segmentConfig: selectConfig,
  segmentId: selectId,
  segmentName: selectName,
  reports: selectMyReports
};

const mapStateToProps = defaultStateForMapStateToProps(defaultState);

const mapDispatchToProps = dispatch => ({
  filtersActions: bindActionCreators(filtersActions, dispatch),
  reportActions: bindActionCreators(reportBuilderActions, dispatch),
  segmentActions: bindActionCreators(
    { saveAudienceSegment, updateFilterOptions, deleteAudienceSegment },
    dispatch
  ),
  userActions: bindActionCreators(userActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserProfileComponent);
